import { ReportSource } from '@/features/Reports/interfaces';

import { MediaResolutionInput, ResolvedMedia } from '../types';
import { isVideoUrlCandidate } from '../utils/contentType';

export const buildMediaResolutionInput = (source: ReportSource): MediaResolutionInput | null => {
  const url = source.url?.trim() ?? '';
  const imageUrl = source.image?.trim() ?? null;

  if (!url && !imageUrl) {
    return null;
  }

  if (url && isVideoUrlCandidate(url)) {
    return {
      url,
      thumbnailUrl: imageUrl,
      title: source.title ?? null,
      description: source.name ?? null,
    };
  }

  if (imageUrl) {
    return {
      url: imageUrl,
      thumbnailUrl: imageUrl,
      title: source.title ?? null,
      description: source.name ?? null,
    };
  }

  if (url) {
    return {
      url,
      thumbnailUrl: imageUrl,
      title: source.title ?? null,
      description: source.name ?? null,
    };
  }

  return null;
};

export const sourceNeedsMediaResolution = (source: ReportSource): boolean => {
  if (!buildMediaResolutionInput(source)) {
    return false;
  }

  if (!source.resolvedMedia) {
    return true;
  }

  return !source.resolvedMedia.resolved;
};

export const attachResolvedMediaToSource = (
  source: ReportSource,
  resolvedMedia: ResolvedMedia
): ReportSource => ({
  ...source,
  resolvedMedia,
});
